/** Build defaults are presentation-only and can be overridden per instance. */
export const UI_DEFAULTS = typeof __XIAOCAI_UI_DEFAULTS__ === 'undefined' ? {
  productName: '小采', productTag: 'AI智能采购助手', customerRoleFallback: '小采',
  emptyStateTitle: '欢迎来到小采', emptyStateDescription: '小采在手，采购不愁。', theme: {},
} : __XIAOCAI_UI_DEFAULTS__;
